import { render } from "./PayGroups.vue?vue&type=template&id=4fd80fe3&scoped=true"
import script from "./PayGroups.vue?vue&type=script&lang=js"
export * from "./PayGroups.vue?vue&type=script&lang=js"

import "./PayGroups.vue?vue&type=style&index=0&id=4fd80fe3&scoped=true&lang=css"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd80fe3"]])

export default __exports__